import styled from 'styled-components'
import { H2 } from '@raysync/common/components'
import { Media } from '@raysync/common/theme'
export const Banner = styled.div`
  height: 460px;
  position: relative;
  h1 {
    padding: 114px 0 15px;
    font-weight: bold;
    line-height: 1.2;
  }
  p {
    max-width: 682px;
    color: #636772;
  }
  ${Media.phone`
     height: 9rem;
     h1 {
      padding: 1rem 0 0;
      text-align: center;
      font-size: .6rem;
     }
     p {
      max-width: unset;
      text-align: center;
      margin-top: .16rem;
     }
  `}
`
export const SearchWrap = styled.div`
  display: flex;
  box-shadow: 0px 2px 10px 0px rgba(99, 103, 114, 0.1);
  border-radius: 25px 25px 25px 25px;
`
export const Title = styled(H2)`
  text-align: center;
  font-weight: 700;
  ${Media.phone`
     font-size: .48rem;
  `}
`
export const Section = styled.section`
  padding: 80px 0;
  background-color: ${p => (p.hasBg ? '#F5F7FB' : '#fff')};
  button.center {
    display: block;
    margin: 0 auto;
  }
  ${Media.phone`
    padding: .8rem 0;
  `}
`
export const DocumentList = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 54px;
  ${Media.phone`
    flex-wrap: wrap;
    margin-top: .6rem;
  `}
`
export const DoucmentItem = styled.div`
  width: 440px;
  height: 320px;
  background: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 20px 20px;
  > div {
    height: 250px;
    border-bottom: 1px solid #d8d8d8;
    display: flex;
    padding: 30px 35px;
    img {
      width: 42px;
      height: 42px;
    }
    div {
      margin-left: 24px;
      h3 {
        font-size: 24px;
        font-weight: 500;
        color: #252a3a;
      }
      ul {
        list-style: none;
        color: #636772;
        margin-top: 16px;
        li {
          line-height: 30px;
          cursor: pointer;
          :hover {
            color: ${p => p.theme.color.secondary};
          }
        }
      }
    }
  }
  a {
    line-height: 70px;
    padding-left: 100px;
    color: ${p => p.theme.color.secondary};
  }
  ${Media.phone`
    width: 100%;
    height: unset;
    border-radius: .2rem;
    margin-bottom: .4rem;
    a {
      line-height: .8rem;
      padding-left: 1.6rem;
      font-size: .28rem;
    }
    > div{
      height: unset;
      padding: .4rem .6rem;
      img {
        width: .6rem;
        height: .6rem;
      }
      div {
        margin-left: .3rem;
        h3 {
          font-size: .36rem;
        }
        ul {
          margin-top: .2rem;
          li {
           font-size: .24rem;
           line-height: 1.8; 
          }
        }
      }
    }
  `}
`
export const VideoList = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 54px 0;
  ${Media.phone`
    flex-wrap: wrap;
    margin: .6rem 0 0;
  `}
`
export const VideoItem = styled.div`
  background: ${p => `url(${p.bg})`};
  background-position: 100% 100%;
  border-radius: 20px;
  box-shadow: 0px 2px 10px 0px rgba(99, 103, 114, 0.1);
  width: 440px;
  height: 242px;
  display: flex;
  justify-content: space-between;
  > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 30px 36px;
    h3 {
      font-weight: bold;
      font-size: 24px;
      line-height: 1.5;
    }
  }
  img {
    width: 180px;
    height: 180px;
  }
  ${Media.phone`
    width: 100%;
    height: 3.7rem;
    margin-bottom: .4rem;
    > div {
      padding: .44rem .36rem;
      h3 {
        font-size: .3rem;
      }
    }
  `}
`
export const PlayIcon = styled.div`
  width: 50px;
  height: 50px;
  background: #ccd0df;
  border-radius: 50%;
  display: flex;
  justify: center;
  align-items: center;
  transition: all 0.3s linear;
  cursor: pointer;
  :hover {
    background: ${p => p.theme.color.secondary};
  }
  span {
    display: block;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 16px solid #fff;
    margin-left: 19px;
  }
`
